import { TSection } from "../../../../components/MiniCards/MiniCards"
import { TDiversCartMiniTable } from "../types/DiversificacionCarteraTypes"

type TFormatMiniTableDataProps = {
    dataMiniCard: TDiversCartMiniTable
}


export const FormatMiniTableData = ({ dataMiniCard } : TFormatMiniTableDataProps) => {
    
    const dataSection: TSection[] = [
        {
            title: "Volatilidad",
            data: `${dataMiniCard.volatilidad.toString()}%`
        },
        {
            title: "Mejoría Diversificación",
            data: `${dataMiniCard.mejoriaDiversificacion.toString()}%`
        },
        {
            title: "Reducción Riesgo",
            data: `${dataMiniCard.reduccionDeRiesgo.toString()}%`
        },
        {
            title: "Índice diversificación",
            data: `${dataMiniCard.indiceDiversificacion.toString()}`
        },
        {
            title: "Número de Instrumentos",
            data: `${dataMiniCard.numeroInstrumentos.toString()}`
        },
        {
            title: "Fecha",
            data: new Date(dataMiniCard.fecha).toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" })
        },
    ]

    return dataSection;
}